/** Calculator map corner: zoom scale, not tray occupancy fill. */
export function calculatorMapScaleLabel(zoom: number): string {
  return `масштаб ${Math.round(zoom * 100)}%`
}
